<template>
    <div>
        <div v-if="region.name === 'Centro-Oeste'">
            <p>
                Existem muitas formas de se contar uma história. Algumas pessoas escrevem, outras
                encenam e têm até aqueles que pintam, em telas enormes, sua própria realidade. Do
                lado de cá a gente também decidiu contar as muitas histórias que caminham pelas
                estradas do Brasil e, para isso, as estampamos em
                <strong>camisetas</strong> , <strong>canecas</strong> ,
                <strong>capas para celular</strong>, <strong>pôsteres</strong> e até
                <strong>bandeiras</strong>. A <strong>Chico Rei</strong> nasce em Minas mas vai até
                o <strong>Centro-Oeste</strong> para ouvir o que o povo tem pra contar e todas as
                nossas <strong>estampas</strong> assumem o compromisso de chegar até você. A gente
                parou pra pensar e viu que só no <strong>Centro-Oeste do Brasil</strong>
                tinha muita história, por isso, criamos uma seleção de produtos dedicados a essa
                região.
            </p>
        </div>
        <div v-if="region.name === 'Nordeste'">
            <p>
                “Muito obrigado ao destino, quanto mais sou
                <strong>nordestino</strong> , mais tenho orgulho de ser.” As palavras do poeta
                <strong>cearense</strong> Bráulio Bessa são tão bonitas que encontram lugar em
                muitos corações. Só quem já foi ao <strong>Nordeste</strong> ou teve a sorte de
                nascer por lá, sabe como a beleza é algo que não tem fim. É beleza
                <strong>cultural</strong> , beleza natural e beleza de gente que sorri pra vida e,
                com todo respeito ao astro, parece iluminar mais do que o sol. Toda essa boniteza
                nos inspirou e aqui na <strong>Chico Rei</strong> você encontra uma seleção que
                estampa o <strong>Nordeste</strong> em suas muitas formas de ser.
            </p>
        </div>
        <div v-if="region.name === 'Norte'">
            <p>
                A <strong>Chico Rei</strong> viaja para que você viaje junto com a gente! O
                atrevimento já dizia que "quem tem limite é município" e por aqui isso fica claro a
                partir do momento que nós levamos nossas estampas para todos os
                <strong>cantos do Brasil</strong>. A gente nasceu em terras mineiras, mas tratou de
                conhecer não apenas a cultura que nos cerca como todas as outras que compõem essa
                brasilidade linda de se ver. Aqui, a gente carrega em cada estampa um pedacinho do
                <strong>Norte</strong>.
            </p>
        </div>
        <div v-if="region.name === 'Sudeste'">
            <p>
                É das poesias de <strong>Milton Nascimento</strong>, do samba e da cantoria alegre
                de <strong>Zeca Pagodinho</strong>, das poesia que falam sobre as belezas dos mares
                de morros e do abraço apertado que o <strong>Sudeste</strong> é feito. Terra de um
                povo plural que ri, sonha e dança com a vida como se ela lhe fosse parceira. A casa
                da <strong>Chico Rei</strong> fica por aqui e junto dela toda a nossa história que
                foi se espalhando pelo <strong>Brasil</strong> , fazendo raiz, gerando fruto e
                cultivando esse sonho a partir de tantos outros que embarcaram nessa com a gente.
                Camisetas contam histórias e nessa seleção tem beleza <strong>sudestina</strong>
                pra todo lado.
            </p>
        </div>
        <div v-if="region.name === 'Sul'">
            <p>
                Se você pensa que <strong>camiseta</strong> é só mais uma peça de roupa, a gente
                está aqui para te dizer que isso não é exatamente verdade. Além de agregar estilo a
                qualquer look, elas também têm a capacidade de contar histórias e
                <strong>estampar</strong> as mais diversas culturas. Da música à poesia, passando
                por mundos imaginários e picos reais, as nossas
                <strong>camisetas contam histórias</strong> e carregam as belezas do nosso Brasil.
                Dessa vez, a <strong>Chico Rei</strong> viajou para o <strong>Sul</strong> e
                estampou toda essa beleza.
            </p>
        </div>
        <ul class="product-list product-list-4 product-list-gap-y-2">
            <ProductListItem
                v-for="product in region.products.data"
                :key="product.id"
                :options="itemOptions"
                :product="product"
            />
        </ul>
    </div>
</template>

<script>
    import { updateLazyLoad } from '../../../common/common';
    import ProductListItem from '../product/ProductListItem';

    export default {
        name: 'CountryRegionProducts',

        components: { ProductListItem },

        props: {
            region: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                itemOptions: {
                    displayName: true,
                    displayPrice: true,
                    displayArt: true,
                    imageWidth: 300,
                },
            };
        },

        mounted() {
            updateLazyLoad();
        },

        watch: {
            region() {
                updateLazyLoad();
            },
        },
    };
</script>
